
'use strict';

(function() {
	angular.module('pphhApp')
		.controller("helpManagerController", ["$scope", "$window", "$mdDialog", "HelpManagerService",
			"pphhEnv", HelpManagerController])
		.controller("helpManagerController_UploadDialogController", ["$scope", "$mdDialog",
			"HelpManagerService", UploadDialogController])
		.controller("dialogShowUpdateController", ["$scope", "$mdDialog", "$window", "HelpManagerService",
			"pphhEnv", "id", "name", DialogShowUpdateController])
		.controller("dialogShowRemoveController", ["$scope", "$mdDialog", "$window", "HelpManagerService",
			"pphhEnv", "id", DialogShowRemoveController]);

	function HelpManagerController($scope, $window, $mdDialog, helpManagerService, pphhEnv) {

		$scope.tagsList = [];
		$scope.filterResults = [];
		$scope.tagsObject = [];
		$scope.nodoTagChecked = [];
		$scope.nameHelp = '';
		$scope.descHelp = '';
		$scope.enlace = '';
		$scope.nameTag = '';

		$scope.init = init;

		$scope.clearFilter = clearFilter;
		$scope.doFilter = innerFilter;

		$scope.openModalUpload = openModalUpload;

		$scope.toggleTags = toggleTags;
		$scope.toggleAll = toggleAll;

		$scope.download = download;
		$scope.removeResource = removeResource;

		$scope.createTag = createTag;
		$scope.openModelRemoveTag = openModelRemoveTag;
		$scope.openModelUpdateTag = openModelUpdateTag;

		function init() {
			$scope.selectAllTags = true;
			helpManagerService.getTags()
				.then(
					function(response) {
						$scope.tagsList = response.data;
						for (var i = 0; i < $scope.tagsList.length; i++) {
							$scope.nodoTagChecked[i] = true;
						}
					}
				);
		}

		function clearFilter() {
			$window.location.href = pphhEnv.global.contextPath + "/helpManager-init";
		}

		function innerFilter(tableState, ctrl) {
			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			helpManagerService.getHelps($scope.nameHelp, $scope.descHelp, $scope.tagsObject)
				.then(
					function(response) {
						$scope.filterResults = response.data;
					}
				);
		}

		function openModalUpload(id) {
			$mdDialog.show({
				clickOutsideToClose: false,
				parent: angular.element(document.body),
				controller: "helpManagerController_UploadDialogController",
				templateUrl: "/helpManager/uploadHelpDialog-init/" + id
			}).then(
				function(answer) {
					if (answer) {
						innerFilter();
					}
				});
		}

		function download(id) {
			var url = pphhEnv.global.contextPath + "/helpManager/resource/" + id + "/file";
			$window.open(url);
		}

		function toggleTags(nodoTagChecked, index) {
			$scope.selectAllTags = true;
			$scope.tagsObject = [];

			$scope.nodoTagChecked[index] = nodoTagChecked;

			if (!nodoTagChecked) {
				$scope.selectAllTags = false;
			}

			if ($scope.selectAllTags) {

				var nodosChecked = true;

				for (var i = 0; i < $scope.tagsList.length; i++) {
					if (!$scope.nodoTagChecked[i]) {
						nodosChecked = false;
					}
				}

				if (!nodosChecked) {
					$scope.selectAllTags = false;
				}
			}

			for (var j = 0; j < $scope.tagsList.length; j++) {
				if (!$scope.nodoTagChecked[j]) {
					$scope.tagsObject.push($scope.tagsList[j].tagId);
				}
			}

			helpManagerService.getHelps($scope.nameHelp, $scope.descHelp, $scope.tagsObject)
				.then(
					function(response) {
						$scope.filterResults = response.data;

					}
				);
		}

		function toggleAll() {
			$scope.tagsObject = [];
			for (var i = 0; i < $scope.tagsList.length; i++) {
				$scope.nodoTagChecked[i] = $scope.selectAllTags;
			}

			for (var j = 0; j < $scope.tagsList.length; j++) {
				if (!$scope.nodoTagChecked[j]) {
					$scope.tagsObject.push($scope.tagsList[j].tagId);
				}
			}

			helpManagerService.getHelps($scope.nameHelp, $scope.descHelp, $scope.tagsObject)
				.then(
					function(response) {
						$scope.filterResults = response.data;
					}
				);
		}

		function createTag(nameTag) {
			if (null == nameTag || nameTag == 'undefined' || nameTag.length <= 0) {
				var alert = $mdDialog.alert({
					title: "Atención",
					textContent: "Etiqueta Vacia",
					ok: "Cerrar"
				});
				$mdDialog.show(alert);
			} else {

				helpManagerService.createTag(nameTag)
					.then(
						function(response) {
							var alert = $mdDialog.alert({
								title: response.data.title,
								textContent: response.data.textContent,
								ok: response.data.ok
							});

							$mdDialog.show(alert)
								.finally(function() {
									$window.location.href = pphhEnv.global.contextPath + "/helpManager-init";
								});
						},

						function(errResponse) {
							var alert = $mdDialog.alert({
								title: errResponse.data.title,
								textContent: errResponse.data.textContent,
								ok: errResponse.data.ok
							});

							$mdDialog.show(alert);
						}
					);
			}
		}

		function openModelRemoveTag(id) {

			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					id: id
				},
				controller: "dialogShowRemoveController",
				templateUrl: "/helpManager/dialog-removeTag"
			});
		}

		function openModelUpdateTag(id, name) {

			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					id: id,
					name: name
				},
				controller: "dialogShowUpdateController",
				templateUrl: "/helpManager/dialog-updateTag"
			});
		}

		function removeResource(id) {
			var confirm = $mdDialog.confirm()
				.title(UIMessages.dialog.confirm.title)
				.textContent(UIMessages.help.removeResource.confirm)
				.ariaLabel(UIMessages.help.removeResource.confirm)
				.ok(UIMessages.dialog.confirm.ok)
				.cancel(UIMessages.dialog.confirm.cancel);

			$mdDialog.show(confirm).then(
				function() {
					helpManagerService.removeResource(id).then(removeResourceSuccessCallback);
				});
		}

		function removeResourceSuccessCallback() {
			$scope.doFilter();
		}
	}

	function DialogShowUpdateController($scope, $mdDialog, $window, helpManagerService, pphhEnv, id, name) {

		$scope.id = id;
		$scope.name = name;  //buscar el nombre que nle puse tagName creo

		$scope.updateTag = updateTag;

		$scope.closeDialog = function() {
			$mdDialog.hide();
		};

		function updateTag(newName) {
			var alert = null;
			if (!newName) {
				alert = $mdDialog.alert({
					title: "Atención",
					textContent: "Etiqueta vacía",
					ok: "Cerrar"
				});
				$mdDialog.show(alert);
			} else {
				helpManagerService.updateTag(id, newName)
					.then(
						function(response) {
							alert = $mdDialog.alert({
								title: response.data.title,
								textContent: response.data.textContent,
								ok: response.data.ok
							});

							$mdDialog.show(alert)
								.finally(function() {
									$window.location.href = pphhEnv.global.contextPath + "/helpManager-init";
								});
						},

						function(errResponse) {
							if (errResponse.status == 409) {
								alert = $mdDialog.alert({
									title: errResponse.data.title,
									textContent: errResponse.data.textContent,
									ok: errResponse.data.ok
								});
							} else {
								alert = $mdDialog.alert({
									title: preconditions.dialog.title,
									textContent: UIMessages.usuario.guardar,
									ok: UIMessages.dialog.confirm.cerrar
								});
							}
							$mdDialog.show(alert);
						}
					);
			}
		}
	}

	function DialogShowRemoveController($scope, $mdDialog, $window, helpManagerService, pphhEnv, id) {

		$scope.id = id;

		$scope.removeTag = removeTag;

		$scope.closeDialog = function() {
			$mdDialog.hide();
		};

		function removeTag() {
			helpManagerService.removeTag(id)
				.then(
					function(response) {
						var alert = $mdDialog.alert({
							title: response.data.title,
							textContent: response.data.textContent,
							ok: response.data.ok
						});
						$mdDialog.show(alert)
							.finally(function() {
								$window.location.href = pphhEnv.global.contextPath + "/helpManager-init";
							});
					},
					function(errResponse) {
						var alert;
						if (errResponse.status == 409) {
							alert = $mdDialog.alert({
								title: errResponse.data.title,
								textContent: errResponse.data.textContent,
								ok: errResponse.data.ok
							});

						} else {
							alert = $mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: UIMessages.usuario.noActualiza,
								ok: UIMessages.dialog.confirm.cerrar
							});
						}

						$mdDialog.show(alert);
					}
				);
		}
	}

	/**
	 * Clase que controla el diálogo de carga de recursos de ayuda
	 */
	function UploadDialogController($scope, $mdDialog, helpManagerService) {
		$scope.tagsTrue = true;
		$scope.filter = {};
		$scope.closeButton = true;

		$scope.init = init;
		$scope.toggle = toggle;
		$scope.closeDialog = closeDialog;
		$scope.closeDialogOk = closeDialogOk;
		$scope.uploadHelpFile = uploadHelpFile;
		$scope.isFormValid = isFormValid;

		function init(id) {
			$scope.id = id;
			$scope.uploadResult = [];
			$scope.tagsList = [];
			$scope.tagsList2 = [];
			$scope.nodoTagChecked = [];
			$scope.nodoTagChecked2 = [];

			if (id != null) {
				helpManagerService.getHelpDoc(id)
					.then(
						function(response) {
							$scope.uploadResult = response.data;
							$scope.descHelp = $scope.uploadResult.descripcion;
							$scope.nameHelp = $scope.uploadResult.nombre;
							$scope.enlace = $scope.uploadResult.enlace;
							$scope.tagsList2 = $scope.uploadResult.tagsList;
						}
					);

			} else {
				$scope.uploadResult.group = "archivo";
				//$scope.isLoading = false;
				helpManagerService.getTags()
					.then(
						function(response) {
							$scope.tagsList = response.data;
							for (var i = 0; i < $scope.tagsList.length; i++) {
								$scope.nodoTagChecked[i] = false;
							}
						}
					);
			}
		}

		function toggle(nodoTagChecked, index) {
			$scope.nodoTagChecked[index] = nodoTagChecked;
		}

		function closeDialog() {
			$mdDialog.hide();
		}

		function closeDialogOk() {
			$mdDialog.hide(true);
		}

		function uploadHelpFile() {

			if (!isFormValid()) {
				return;
			}

			if ($scope.uploadResult.group === 'archivo') {
				$scope.enlace = null;
			} else if ($scope.uploadResult.group === 'enlace') {
				$scope.file = null;
			}

			$scope.tagsObject = [];

			if ($scope.tagsList.length == 0) {

				for (var j = 0; j < $scope.tagsList2.length; j++) {
					if ($scope.nodoTagChecked2[j]) {
						$scope.tagsObject.push($scope.tagsList2[j].tagId);
					}
				}
			} else {

				for (var k = 0; k < $scope.tagsList.length; k++) {
					if ($scope.nodoTagChecked[k]) {
						$scope.tagsObject.push($scope.tagsList[k].tagId);
					}
				}
			}

			/**
			 * Callback que se invoca cuando la operación de carga se ha realizado
			 * correctamente.
			 */
			var uploadFileSuccessCallback = function(response) {

				var messages = response.messages;
				var field = messages[0];
				$scope.message = field.message;

				var tags = response.tags;

				$scope.tags = tags;

				$scope.closeButton = false;
			};

			/**
			 * Callback que se invoca cuando se ha producido algún error durante la
			 * operación de carga.
			 */
			var uploadFileErrorCallback = function(response) {

				var errorMessages = response.errorMessages;
				if (errorMessages != null) {
					var field = errorMessages[0];
					$scope.message = field.message;
				} else {
					$scope.message = UIMessages.global.errorInesperado;
				}

				$scope.closeButton = false;
			};

			helpManagerService.uploadHelpFile($scope.id, $scope.file, $scope.nameHelp,
				$scope.descHelp, $scope.enlace, $scope.tagsObject).then(
					uploadFileSuccessCallback, uploadFileErrorCallback);
		}

		function isFormValid() {
			var invalid =
				($scope.id == null
					&& $scope.uploadResult.group === 'archivo'
					&& $scope.file == null)
				|| ($scope.uploadResult.group === 'enlace'
					&& $scope.enlace == null)
				|| !$scope.helpDocForm.$valid;

			return !invalid;
		}
	}
})();
